import Swiper from "swiper/bundle";

export const recommendSwiper = new Swiper(".js-recommend-slide", {
  loop: false,
  centeredSlides: false,
  slidesPerView: 'auto',
  speed: 500,
  navigation: {
    nextEl: ".c-recommend .swiper-button-next",
    prevEl: ".c-recommend .swiper-button-prev",
  },
  scrollbar: {
    el: ".c-recommend .swiper-scrollbar",
    hide: false,
    draggable: true,
  },
});
